module.exports = __webpack_public_path__ + "media/application/images/2018/twitter-red@2x-d60c7c31521d11cef78b4c0e695e72d2.png";